import React from "react";
import GalleryVideoDetailsPlayer from "../../pages/events/ViewPhoto/GalleryVideoDetailsPlayer";

const ThreeInOnePlayerFast = ({ activeItemIndex, dataSlider, threeInOneFastShareDetails }) => (
  <GalleryVideoDetailsPlayer
    activeItemIndex={activeItemIndex}
    dataSlider={dataSlider}
    directory="burstgif"
    fileKey="event_gif"
    initialDetails={threeInOneFastShareDetails}
    title="3 in 1 fast details"
  />
);

export default ThreeInOnePlayerFast;
